<template>
    <AccessControl :menuId="4" :menuSectionId="9" nameOfPage='Supplier List' @accessGranted="handleAccess">
    </AccessControl>
    <MainLayout>
        <template v-slot:default>
            <!-- end: container -->
            <!-- begin: container -->
            <div class="container-fixed">

                <div class="flex flex-wrap items-center lg:items-end justify-between gap-5 pb-7.5">
                    <div class="flex flex-col justify-center gap-2">
                        <h1 class="text-xl font-semibold leading-none text-gray-900">
                            Supplier List
                        </h1>
                    </div>
                    <div class="flex items-center gap-2.5">
                        <a v-if="canWrite" class="btn btn-sm btn-success" @click="openAdd">
                            Add Supplier
                        </a>
                    </div>
                </div>

                <Notification ref="notificationRef" />

                <div class="card">
                    <div class="card-header card-header-bg flex-wrap gap-2">
                        <div class="flex flex-wrap gap-2 lg:gap-5">
                            <div class="flex"><label class="input input-sm"><i class="ki-filled ki-magnifier"></i><input
                                        value="" v-model="searchTerm" type="text" placeholder="Search table"
                                        @input="fetchData"></label>

                                <label class="input input-sm" style="margin-left:10px;">Date From:<input value=""
                                        v-model="dateFrom" type="date" @input="fetchData"></label>


                                <label class="input input-sm" style="margin-left:10px;">Date To:<input value=""
                                        v-model="dateTo" type="date" @input="fetchData"></label>
                                <div>

                                    <button :disabled="export_loading" type="button" style="margin-left:10px;"
                                        @click="generate_report" ref="addRow"
                                        class="w-32 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 mr-1">
                                        <span v-if="export_loading" class="spinner"></span>
                                        <span v-else>Generate Report</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <vue-good-table mode="remote" :server-side="true" :columns="columns" :rows="rows"
                        :total-rows="totalRows" :pagination-options="paginationOptions" :isLoading.sync="isLoading"
                        :search-options="{ enabled: false }" @page-change="onPageChange" @on-page-change="onPageChange"
                        @per-page-change="onPerPageChange" @sort-change="onSortChange">
                        <template #table-row="props">
                            <span v-if="props.column.field === 'actions'">

                                <a @click="showProduct(props.row)" class="btn btn-sm btn-icon btn-clear btn-light"
                                    href="#">
                                    <i class="ki-filled ki-filled ki-questionnaire-tablet" title="View Products">
                                    </i>
                                </a>

                                <a @click="generate_report_detail(props.row)"
                                    class="btn btn-sm btn-icon btn-clear btn-light" href="#">
                                    <i class="ki-filled ki-exit-down"></i>
                                </a>

                                <a v-if="canEdit" @click="handleEdit(props.row)"
                                    class="btn btn-sm btn-icon btn-clear btn-light" href="#">
                                    <i class="ki-filled ki-notepad-edit">
                                    </i>
                                </a>

                                <a v-if="canDelete" @click="handleDelete(props.row)"
                                    class="btn btn-sm btn-icon btn-clear btn-light" href="#">
                                    <i class="ki-filled ki-trash">
                                    </i>
                                </a>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>

                    </vue-good-table>

                    <Modal :isVisible="showModal" @update:isVisible="showModal = $event">
                        <template v-slot:header>
                            <h2>Add Supplier</h2>
                        </template>
                        <template v-slot:body>
                            <form @submit.prevent="submitForm" style="width: 100%;">

                                <div class="grid grid-cols-3 gap-4">
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Supplier Name
                                            </label>
                                            <input required v-model="form.supplier_name"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Address 1
                                            </label>
                                            <input required v-model="form.address_1"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Address 2
                                            </label>
                                            <input required v-model="form.address_2"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-4 gap-4">
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Country
                                            </label>
                                            <select @change="handleCountryChange" id="country_id" ref="country_id"
                                                required v-model="form.country_id"
                                                class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                <option value="0" selected>-Select-</option>
                                                <option v-for="country in countty_list" :key="country.country_id"
                                                    :value="country.country_id">
                                                    {{ country.country_name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Province
                                            </label>
                                            <select @change="handleProvinceChange" required v-model="form.province_id"
                                                ref="province_id"
                                                class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                <option value="0" selected>- Select -</option>
                                                <!-- Placeholder option -->
                                                <option v-for="province in province_list" :key="province.province_id"
                                                    :value="province.province_id">
                                                    {{ province.province_name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                City
                                            </label>
                                            <select ref="city_id" required v-model="form.city_id"
                                                class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                <option value="0" selected>- Select -</option>
                                                <option v-for="city in city_list" :key="city.city_id"
                                                    :value="city.city_id">
                                                    {{ city.city_name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Zip Code
                                            </label>
                                            <input v-model="form.zip_code"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-3 gap-4">
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Email Address
                                            </label>
                                            <input v-model="form.email"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="email" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Phone Number
                                            </label>
                                            <input v-model="form.phone_number"
                                                class="shadow appearance-none border  border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Mobile Number
                                            </label>
                                            <input v-model="form.mobile_number"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-3 gap-4">
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Contact Person
                                            </label>
                                            <input v-model="form.contact_person"
                                                class="shadow appearance-none border border-gray-500  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Contact Email Address
                                            </label>
                                            <input v-model="form.contact_email_address"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Contact Mobile Number
                                            </label>
                                            <input v-model="form.contact_mobile_number"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                </div>

                                <div class="flex justify-end mt-4">
                                    <button type="button" @click="closeModal"
                                        class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 mr-1">Close</button>
                                    <button type="submit" v-if="canWrite"
                                        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Save</button>
                                </div>
                            </form>
                        </template>
                    </Modal>

                    <Modal :isVisible="showModal2" @update:isVisible="showModal2 = $event" @click.stop>
                        <template v-slot:header>
                            <h2>Add Supplier</h2>
                        </template>
                        <template v-slot:body>
                            <form @submit.prevent="updateForm" style="width: 100%;">

                                <div class="grid grid-cols-3 gap-4">
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Supplier Name
                                            </label>
                                            <input required v-model="currentItem.supplier_name"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Address 1
                                            </label>
                                            <input required v-model="currentItem.supplier_address1"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Address 2
                                            </label>
                                            <input required v-model="currentItem.supplier_address2"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-4 gap-4">
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Country
                                            </label>
                                            <select @change="handleCountryChange" id="country_id" ref="country_id2"
                                                required v-model="currentItem.country_id"
                                                class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                <option value="0" selected>-Select-</option>
                                                <option v-for="country in countty_list" :key="country.country_id"
                                                    :value="country.country_id">
                                                    {{ country.country_name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Province
                                            </label>
                                            <select @change="handleProvinceChange" required
                                                v-model="currentItem.province_id" ref="province_id2"
                                                class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                <option value="0" selected>- Select -</option>
                                                <!-- Placeholder option -->
                                                <option v-for="province in province_list" :key="province.province_id"
                                                    :value="province.province_id">
                                                    {{ province.province_name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                City
                                            </label>
                                            <select ref="city_id2" required v-model="currentItem.city_id"
                                                class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                <option value="0" selected>- Select -</option>
                                                <option v-for="city in city_list" :key="city.city_id"
                                                    :value="city.city_id">
                                                    {{ city.city_name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Zip Code
                                            </label>
                                            <input v-model="currentItem.zipcode"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-3 gap-4">
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Email Address
                                            </label>
                                            <input v-model="currentItem.email_address"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="email" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Phone Number
                                            </label>
                                            <input v-model="currentItem.phone_number"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Mobile Number
                                            </label>
                                            <input v-model="currentItem.mobile_number"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-3 gap-4">
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Contact Person
                                            </label>
                                            <input v-model="currentItem.contact_person"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Contact Email Address
                                            </label>
                                            <input v-model="currentItem.contact_email_address"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="mb-4">
                                            <label class="block text-gray-700 text-left text-sm font-bold mb-2" for="">
                                                Contact Mobile Number
                                            </label>
                                            <input v-model="currentItem.contact_mobile_number"
                                                class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                type="text" placeholder="">
                                        </div>
                                    </div>
                                </div>

                                <div class="flex justify-end mt-4">
                                    <button type="button" @click="closeModal2"
                                        class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 mr-1">Close</button>
                                    <button v-if="canEdit" type="submit"
                                        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Update</button>
                                </div>
                            </form>
                        </template>
                    </Modal>



                </div>
            </div>
            <!-- end: container -->
        </template>
    </MainLayout>
</template>
<script>
import MainLayout from '@/components/MainLayout.vue'
import apiClient from '@/services/apigen'; // Import your configured Axios instance  
import { ref, watch, onMounted } from 'vue';
import { VueGoodTable } from 'vue-good-table-next';
import Modal from '@/components/utils/Modal2.vue'
import 'vue-good-table-next/dist/vue-good-table-next.css';
import Loader from '@/components/utils/loader.vue';
import Swal from 'sweetalert2';
import Notification from '@/components/utils/Notification.vue';
import AccessControl from '@/components/utils/UserAccess.vue';

export default {
    name: 'SupplierListPage',
    components: {
        MainLayout,
        VueGoodTable,
        Modal,
        Notification,
        AccessControl
    },
    setup() {
        const columns = ref([
            { label: '#', field: 'supplier_id', type: 'number', sortable: true },
            { label: 'Supplier Name', field: 'supplier_name', sortable: true },
            { label: 'Email Address', field: 'email_address', sortable: true },
            { label: 'Phone Number', field: 'phone_number', sortable: true },
            { label: 'Contact Person', field: 'contact_person', sortable: true },
            { label: 'Contact Email Address', field: 'contact_person', sortable: true },
            { label: 'Contact Mobile Number', field: 'contact_mobile_number', sortable: true },
            { label: 'Phone Number', field: 'phone_number', sortable: true },
            {
                sortable: false,
                label: 'Actions',
                field: 'actions',
                type: 'actions',
                actions: [
                    {
                        label: 'Edit',
                        icon: 'edit',
                        onClick: ""
                    },
                    {
                        label: 'Delete',
                        icon: 'delete',
                        onClick: ""
                    }
                ]
            }
        ]);

        const rows = ref([]);
        const totalRows = ref(0);
        const searchTerm = ref('');
        const currentPage = ref(1);
        const perPage = ref(20);
        const sortField = ref('supplier_name');
        const sortType = ref('asc');
        const dateFrom = ref('');
        const dateTo = ref('');


        const paginationOptions = ref({
            enabled: true,
            mode: 'pages',
            perPageDropdown: [5, 10, 20],
            perPage: perPage.value,
            totalRecords: totalRows.value,
            currentPage: currentPage.value

        });

        const searchOptions = {
            enabled: true
        };

        // Function to fetch data from the server
        const fetchData = async (page) => {
            try {
                const params = {
                    page: page,
                    per_page: perPage.value,
                    sort_field: sortField.value,
                    sort_type: sortType.value,
                    search: searchTerm.value,
                    date_from: dateFrom.value,
                    date_to: dateTo.value
                };
                const { data } = await apiClient.get('/supplier', { params });
                rows.value = data.data || [];
                totalRows.value = data.total || 0;

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        const onPageChange = ({ currentPage }) => {
            paginationOptions.currentPage = currentPage;
            fetchData(currentPage);
        };

        const onPerPageChange = ({ currentPerPage }) => {
            console.log('Per page changed to:', currentPerPage);
            perPage.value = currentPerPage;
            paginationOptions.value.perPage = currentPerPage;
            fetchData();
        };

        const onSortChange = ([sort]) => {
            console.log('Sort changed to:', sort);
            sortField.value = sort.field;
            sortType.value = sort.type;
            fetchData();
        };
        // Watch for changes to trigger fetchData
        watch([currentPage, perPage, sortField, sortType, searchTerm, dateFrom, dateTo], fetchData, { immediate: true });
        return {
            columns,
            rows,
            totalRows,
            paginationOptions,
            searchTerm,
            onPageChange,
            onPerPageChange,
            onSortChange,
            isLoading: false,
            dateFrom,
            dateTo
        };
    },
    methods: {

        async generate_report_detail(data) {

            let id = data.supplier_id;

            const params = {
                id: id,

            };

            try {
                const response = await apiClient.get(`/report/supplier_detail`, {
                    params,
                    responseType: 'blob', // Important for binary data
                });
                // Create a blob from the response data
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Supplier_Detail.xlsx'); // Set the desired file name
                document.body.appendChild(link);
                link.click();
                // Clean up the link
                link.parentNode.removeChild(link);
                this.export_loading = false;
            } catch (error) {
                console.error('Error downloading customer report:', error);
            }
        },

        async generate_report() {

            let fromDate = this.dateFrom;
            let toDate = this.dateTo;
            let searchTerm = this.searchTerm;

            if (fromDate == "" || toDate == "") {
                this.$refs.notificationRef.show("Please select Date Range", 'error', '0');
                return false;
            }
            this.export_loading = true; // Set loading state to true
            const params = {
                search: searchTerm,
                date_from: fromDate,
                date_to: toDate
            };

            try {
                const response = await apiClient.get(`/report/supplier`, {
                    params,
                    responseType: 'blob', // Important for binary data
                });

                // Create a blob from the response data
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Supplier.xlsx'); // Set the desired file name
                document.body.appendChild(link);
                link.click();
                // Clean up the link
                link.parentNode.removeChild(link);
                this.export_loading = false;
            } catch (error) {
                console.error('Error downloading customer report:', error);
            }

        },

        openAdd() {
            window.location = '/supplier/add';
        },
        showProduct(data) {
            window.location = '/supplier/get_products/' + data.supplier_id;
        },
        handleEdit(data) {

            window.location = '/supplier/edit/' + data.supplier_id;
            //this.showInfo(data.supplier_id);
        },
        handleDelete(data) {

            let supplier_id = data.supplier_id;

            Swal.fire({
                title: 'Are you sure do you want to delete?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteData(supplier_id);
                }
            });
        },
        async deleteData(id) {

            try {
                const response = await apiClient.delete('/supplier/delete', { data: { id: id } });
                if (response.data.status == true) { // or check for other success c
                    this.$refs.notificationRef.show('Successfully Deleted', 'success', '1');
                } else {
                    this.$refs.notificationRef.show(response.data.message, 'error', '0');
                }
            } catch (error) {
                console.error('Error submitting form:', error.response);
                loader.hide();
            }
        },
        handleAccess({ canEdit, canDelete, canWrite }) {
            this.canEdit = canEdit;
            this.canDelete = canDelete;
            this.canWrite = canWrite;
        },



    },
    data() {
        return {
            showModal: false,
            form: {},
            showModal2: false,
            currentItem: [

            ],
            countty_list: [],
            province_list: [],
            city_list: [],
            edit_first: 0,
            canWrite: 0,
            canEdit: 0,
            canDelete: 0,
        };
    },


}
</script>


<style></style>